<template>
  <div id="blade5a">
    <GroupContainer class="blade-5a-group-cntnr" :obj="stObj.gC">
      <template #slot1>
        <TwelveCol>
          <template slot="slot1">
            <SixBySix :obj="stObj.eBf">
              <div class="col no-padding" slot="slot1">
                <h2
                  class="blade-5a-headline"
                  slot="slot1"
                  v-html="stObj.title"
                  data-aos="fade-left"
                  data-aos-delay="500"
                ></h2>
              </div>
              <div slot="slot2">
                <p
                  class="body blade-5a-p"
                  v-for="(p, index) in stObj.paragraphs"
                  v-html="p"
                  :key="`blade5a-p-${index}`"
                  data-aos="fade-up"
                  data-aos-delay="1000"
                ></p>
              </div>
            </SixBySix>
            <div class="col-sm-12 blade-5a-second-headline lg">
              <h4>Why this partnership:</h4>
            </div>
            <div class="col-sm-12 blade-5a-second-headline md">
              <h4>Why this partnership:</h4>
            </div>
            <TwelveCol class="spacing blade-5-icons blackbackground">
              <template slot="slot1">
                <FeatureIcon
                  v-for="(fIc, index) in stObj.featureic1"
                  :obj="fIc"
                  :key="`fIc-1-${index}`"
                  :tabindex="`${index + 5}`"
                />
              </template>
            </TwelveCol>
          </template>
        </TwelveCol>
      </template>
    </GroupContainer>
  </div>
</template>

<script>
import SixBySix from "../../../2019-immersive-modular-experience/src/components/SixBySix";
import GroupContainer from "../../../2019-immersive-modular-experience/src/components/GroupContainer";
import TwelveCol from "../../../2019-immersive-modular-experience/src/components/TwelveCol";
import { inView } from "../../helpers/inView";
import {
  setUpBlade5aAnimation,
  blade5aanimation,
  blade5Iconanimation
} from "../../helpers/blade5a";
import FeatureIcon from "../../components/blade5-sections/2020FeatureIcon";

export default {
  name: "Blade5a",
  components: {
    SixBySix,
    GroupContainer,
    TwelveCol,
    FeatureIcon
  },
  data: function() {
    return {
      hasAnimated: false,
      subHeaderAnimated: false,
      iconsAreVisible: false
    };
  },
  computed: {
    stObj() {
      return this.$store.state.blade5a;
    }
  },
  methods: {
    hasSubheaderAnimated() {
      if (!this.subHeaderAnimated) {
        if (window.innerWidth >= 992) {
          this.subHeaderAnimated = inView(
            ".blade-5a-second-headline.lg",
            blade5aanimation,
            "all"
          );
          document.addEventListener("scroll", this.revealIcons);
        } else {
          this.subHeaderAnimated = inView(
            ".blade-5a-second-headline.md",
            blade5aanimation,
            "all"
          );
          document.addEventListener("scroll", this.revealIcons);
        }
      } else {
        document.removeEventListener("scroll", this.hasSubheaderAnimated);
      }
    },
    revealIcons() {
      if (!this.iconsAreVisible) {
        this.iconsAreVisible = inView(
          ".blade-5-icons",
          blade5Iconanimation,
          "mid"
        );
      } else {
        document.removeEventListener("scroll", this.revealIcons);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setUpBlade5aAnimation();
      this.hasSubheaderAnimated();
      document.addEventListener("scroll", this.hasSubheaderAnimated);
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.hasSubheaderAnimated);
    document.removeEventListener("scroll", this.revealIcons);
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/blade5a.scss";
</style>
